"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCoupon = addCoupon;
exports.deleteCoupon = deleteCoupon;
exports.getCouponById = getCouponById;
exports.getCouponPage = getCouponPage;
exports.getCouponPageList = getCouponPageList;
exports.issueCoupon = issueCoupon;
exports.syncCoupon = syncCoupon;
exports.syncTcCoupon = syncTcCoupon;
exports.updateCoupon = updateCoupon;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 分页查询券类型表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
function getCouponPageList(params) {
  return (0, _requestAuth.default)({
    url: '/xyCouponType/pageList',
    method: 'get',
    params: params
  });
}
function getCouponPage(params) {
  return (0, _requestAuth.default)({
    url: '/xyCouponType/page',
    method: 'get',
    params: params
  });
}
/**
 * 获取优惠券详情
 * @param {Number} id 优惠券类型ID
 * @returns {Promise}
 */
function getCouponById(id) {
  return (0, _requestAuth.default)({
    url: "/xyCouponType/".concat(id),
    method: 'get'
  });
}

/**
 * 新增优惠券类型
 * @param {Object} data 优惠券类型数据
 * @returns {Promise}
 */
function addCoupon(data) {
  return (0, _requestAuth.default)({
    url: '/xyCouponType',
    method: 'post',
    data: data
  });
}

/**
 * 编辑优惠券类型
 * @param {Object} data 优惠券类型数据
 * @returns {Promise}
 */
function updateCoupon(data) {
  return (0, _requestAuth.default)({
    url: '/xyCouponType',
    method: 'put',
    data: data
  });
}

/**
 * 删除优惠券类型
 * @param {Number} id 优惠券类型ID
 * @returns {Promise}
 */
function deleteCoupon(id) {
  return (0, _requestAuth.default)({
    url: '/xyCouponType',
    method: 'delete',
    params: {
      id: id
    }
  });
}

/**
 * 发放优惠券
 * @param {Object} data 发放数据
 * @returns {Promise}
 */
function issueCoupon(data) {
  return (0, _requestAuth.default)({
    url: '/exBonusType/sendCouponUser',
    method: 'post',
    data: data
  });
}

/**
 * 同步优惠券数据
 * @param {Number} id 优惠券类型ID
 * @returns {Promise}
 */
function syncCoupon(id) {
  return (0, _requestAuth.default)({
    url: "/xyCouponType/sync/".concat(id),
    method: 'get'
  });
}

/**
 * 同步天财券
 * @param {Number} couponId 优惠券ID
 * @returns {Promise}
 */
function syncTcCoupon(couponId) {
  return (0, _requestAuth.default)({
    url: '/xyCouponType/syncTcCoupon',
    method: 'get',
    params: {
      couponId: couponId
    }
  });
}